import ApiService from '@/services/api';
const API = new ApiService();
// import _ from 'lodash';

export const state = {
  checkoutItems: [],
  checkoutTotalRows: 0,
}

export const mutations = {
  SET_CHECKOUT_ITEMS(state, listings) {
    // console.log("checkoutItems", JSON.stringify(listings));
    for(let l of listings){
      l["toggle"] = true; // for toggle of listing of spaces
    }
    state.checkoutItems = listings;
  },
  UPDATE_TOTAL_CHECKOUT(state, pageInfo){
    state.checkoutTotalRows = pageInfo;
  },
  TOGGLE_STORE_SPACES(state, item){
    for(let l of state.checkoutItems){
      if(item.businessId == l.businessId){
        l["toggle"] = !l["toggle"];
      }
    }
  },
}

export const getters = {
}

export const actions = {
  fetchCheckoutItems({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/checkout/list')
        .then(res => {
          commit('SET_CHECKOUT_ITEMS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  addToCart({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/checkout/add-to-cart', params)
        .then(res => {
          commit('UPDATE_TOTAL_CHECKOUT', 0);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  toggleStoreSpaces({ commit }, params) {
    return commit('TOGGLE_STORE_SPACES', params);
  },
  confirmOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/checkout/confirm-order', params)
        .then(res => {
          // commit('SET_CHECKOUT_ITEMS', []);
          commit('UPDATE_TOTAL_CHECKOUT', 0);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
}

